import React from "react";
import {FormikErrors, FormikTouched} from "formik";
import DateRangePicker from '@wojtekmaj/react-daterange-picker';

interface BYRangeDatePickerProps {
    title?: string;
    name?: string;
    disabled?: boolean;
    touched?: boolean | FormikTouched<any> | FormikTouched<any>[];
    error?: string | string[] | FormikErrors<any> | FormikErrors<any>[];
    onChange?: (arg0: (string | Date)[]) => void;
    value?: (string | Date)[];
    required?: boolean;
}

const BYRangeDatePicker = (props: BYRangeDatePickerProps) => {
    const {title, disabled, touched, error, onChange, value, required, name} = props;

    const displayError = touched && error;

    let [fromValue, toValue] = value;
    if (typeof fromValue === 'string') {
        fromValue = new Date(fromValue);
    }
    if (typeof toValue === 'string') {
        toValue = new Date(toValue);
    }

    return <>
        {title && <label className="form-label">{title}</label>}
        <div>
            <DateRangePicker
                format="dd/MM/yyyy"
                className="form-control"
                onChange={(newValue) => {
                    onChange(newValue || [null, null]);
                }}
                value={[fromValue, toValue]}
                required={required}
                disabled={disabled}
                name={name}
            />
        </div>
        {displayError && <div className="text-danger font-weight-bold">{error}</div>}
    </>
};

export default BYRangeDatePicker;